<form >
  <h4>Importação de extratos</h4>
  <input type="file" (change)="changeArquivo($event)" style="width: 100%;" />
  <br/>
  <button mat-raised-button type="button" style="width: 100%; margin-top: 10px;" (click)="submitArquivo()" color="primary">
    Confirmar e gerar APRS
  </button>
</form>